module.exports = __webpack_public_path__ + "img/23.65f40dc1.svg";